import { __decorate, __metadata, __param } from "tslib";
import { i18nSymbol } from '@/i18n';
import { inject, provide } from '@/inversify.config';
import { CommentsAPI } from '@cores/apis/workspace_api/comments.api';
import _ from 'lodash';
export const CommentsServiceSymbol = Symbol.for('CommentsService');
let CommentsService = class CommentsService {
    constructor(i18n) {
        this.i18n = i18n;
        this.cachedCommentIds = [];
        this.cachedCommentsMap = {};
    }
    addCachedCommentIds(ids = []) {
        this.cachedCommentIds = _.uniq(_.concat(this.cachedCommentIds, ids));
    }
    removeCachedCommentIds(ids = []) {
        this.cachedCommentIds = _.difference(this.cachedCommentIds, ids);
    }
    addCachedCommentsMap(commentsMap = {}) {
        this.cachedCommentsMap = _.merge(this.cachedCommentsMap, commentsMap);
    }
    getCachedCommentsMap(ids = []) {
        return _.pick(this.cachedCommentsMap, ids);
    }
    resetCachedCommentIds() {
        this.cachedCommentIds = [];
        this.cachedCommentsMap = {};
    }
    getCommentsWithMergeApi(input) {
        if (_.indexOf(this.cachedCommentIds, input.data_ids[0]) > -1) {
            return Promise.resolve(this.getCachedCommentsMap(input.data_ids));
        }
        return CommentsAPI.getCommentsWithMergeApi({ ...input, data_ids: input.data_ids }).then(res => {
            this.addCachedCommentIds(input.data_ids);
            this.addCachedCommentsMap(res);
            return res;
        }).catch(err => {
            this.removeCachedCommentIds(input.data_ids);
            return Promise.reject(err);
        });
    }
    getCommentsApi(input) {
        return CommentsAPI.getCommentsApi(input);
    }
    getCommentsByDataId(commentsMap = {}, data_id) {
        return _.get(commentsMap, `[${data_id}].comments`);
    }
    addCommentApi(input) {
        return CommentsAPI.addCommentApi(input);
    }
    updateCommentApi(input) {
        return CommentsAPI.updateCommentApi(input);
    }
    deleteCommentApi(input) {
        return CommentsAPI.deleteCommentApi(input);
    }
};
CommentsService = __decorate([
    provide(CommentsServiceSymbol),
    __param(0, inject(i18nSymbol)),
    __metadata("design:paramtypes", [Object])
], CommentsService);
export { CommentsService };
